<h6 (click)="openDetailInfo(wall.from_id)" class="mb-2 font-weight-bold pointer">
  <span [innerHTML]="message.text_list + ' '"></span>
  <a
    *ngIf="wall.name"
    [innerHTML]="wall?.name?.first + ' ' + wall?.name?.last | replaceEmojis: 'facebook':20:64"
    class="pointer"
  ></a>
</h6>
<small class="opacity-65 mr-2">
  <i-feather name="calendar"></i-feather>
  {{ wall.date * 1000 | date: 'shortTime' }}
</small>

<div class="message-body py-2 py-lg-3" [ngClass]="{ 'message-attachments': wall.attachments?.length > 0 }">
  <div class="message-row">
    <div class="message-content">
      <div *ngIf="wall.text" [innerHTML]="wall.text | href | replaceEmojis: 'facebook':24:64" class="text-break"></div>
      <app-message-attachments
        [messagesContainer]="messagesContainer"
        [messageBody]="messageBody"
        [lvl]="lvl"
        *ngIf="wall.attachments?.length > 0"
        [Service]="Service"
        [message]="wall"
        class="mt-2 d-block"
      ></app-message-attachments>
      <div class="message-bottom position-relative mt-2 d-flex justify-content-between">
        <div tooltip="Лайков" *ngIf="wall?.likes?.count" class="ml-2">
          <i-feather name="heart"></i-feather>
          <span class="ml-2">{{ makeFriendly(wall.likes.count) }}</span>
        </div>
        <div tooltip="Комментариев" *ngIf="wall?.comments?.count" class="ml-2">
          <i-feather name="message-circle"></i-feather>
          <span class="ml-2">{{ makeFriendly(wall.comments.count) }}</span>
        </div>
        <div tooltip="Репостов" *ngIf="wall?.reposts?.count" class="ml-2">
          <i-feather name="corner-up-left"></i-feather>
          <span class="ml-2">{{ makeFriendly(wall.reposts.count) }}</span>
        </div>
        <div placement="top" ngbTooltip="Просмотров" *ngIf="wall?.views?.count" class="ml-2">
          <i-feather name="eye"></i-feather>
          <span class="ml-2">{{ makeFriendly(wall.views.count) }}</span>
        </div>
      </div>
      <div *ngIf="wall.copy_history?.length > 0">
        <app-message-wall
          [Service]="Service"
          [class.message-right]="message.out"
          [message]="message"
          [wall]="wall.copy_history[0]"
          [messagesContainer]="messagesContainer"
          [messageBody]="messageBody"
          class="mb-2 d-block"
          [lvl]="lvl"
          id="wall-{{ wall.copy_history[0]?.id }}"
        ></app-message-wall>
      </div>
    </div>
  </div>
</div>
